"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockContent = exports.newCourses = void 0;
/* eslint-disable import/prefer-default-export */
exports.newCourses = {
    courses: [
        {
            uuid: '25479852-8923-47a7-9662-4d7f7f4076ee',
            name: 'Kubernetes',
            description: 'Welcome aboard! You are about to embark on a dynamic Kubernetes Security course that is tailor-made to equip you with crucial knowledge and skills needed to fortify Kubernetes environments. Kubernetes is not just a tool, it is the backbone of container orchestration that is essential for running applications. As more organizations adopt this technology, there is an increasing demand for professionals who understand how to keep it secure. Let’s get you ready to meet that demand!  Kubernetes is not just a tool, it is the backbone of container orchestration that is essential for running applications. As more organizations adopt this technology, there is an increasing demand for professionals',
            iconUrl: 'https://content.codebashing.com/courses-assets/3ee63537-b32a-42bb-97a4-ad7fcbea8b0e.webp',
            numberOfLessons: 12,
            points: 12000,
            score: 100,
            completionPercentage: 100,
        },
        {
            uuid: '4890d2ef-6b97-470c-8a74-755a0215060c',
            name: 'OWASP LLM Vulnerabilities',
            description: 'Welcome to the OWASP LLM Vulnerabilities course. Learn the essentials of securing Large Language Models (LLMs) in AI, covering everything from basic concepts to advanced security practices.',
            iconUrl: 'https://content.codebashing.com/courses-assets/7487169c-4d81-4df8-82c6-e848f9a0bed4.webp',
            numberOfLessons: 3,
            points: 2000,
            score: 5000,
            completionPercentage: 100,
        },
        {
            uuid: '94fe9032-b093-49e9-81ed-5bee3b9a1b47',
            name: 'test units 123',
            description: 'test units',
            iconUrl: 'https://platform-ui-spa.devcodebashing.com/icons/customCourses/default/custom-course-default.webp',
            numberOfLessons: 11,
            points: 4000,
            score: 0,
            completionPercentage: 60,
        },
        {
            uuid: 'e1eef087-33a8-483a-a581-6ce7242b1e73',
            name: 'test Chedva',
            description: 'test',
            iconUrl: 'https://platform-ui-spa.devcodebashing.com/icons/customCourses/default/custom-course-default.webp',
            numberOfLessons: 7,
            points: 5000,
            score: 400,
            completionPercentage: 50,
        },
    ],
    success: true,
};
exports.mockContent = {
    content: [
        {
            contentType: 'Lesson',
            data: [
                {
                    id: 735,
                    uuid: '664dd6b06ea5284730ded8c5',
                    displayName: 'Log Forging and Logging Sensitive Data',
                    description: 'In this lesson, we will explore the security issues of log forging and logging sensitive data in software development. We will examine how these vulnerabilities can be exploited and learn best practices for preventing them to ensure secure logging practices.',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/311af952-fd59-4669-b15f-091c920b5493.webp',
                    name: 'log_forging_and_logging_sensitive_data_lesson_outline',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2024-05-22T13:05:50.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: null,
                    owasp: null,
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: null,
                    systemCourseDisplayName: 'Cobol',
                    url: '/courses/cobol/lessons/log_forging_and_logging_sensitive_data_lesson_outline',
                },
                {
                    id: 736,
                    uuid: '664afbb615b1380a57b41019',
                    displayName: 'Authorization in APIs',
                    description: 'In this interactive tutorial, you will refresh your knowledge of what the “authorization” term means. You’ll also learn how authorization is implemented and used in the API context.\n',
                    duration: '5-8',
                    iconUrl: null,
                    name: 'authorization_in_ap_is',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2024-05-22T13:05:50.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: null,
                    owasp: null,
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: null,
                    systemCourseDisplayName: 'Cobol',
                    url: '/courses/cobol/lessons/authorization_in_ap_is',
                },
                {
                    id: 734,
                    uuid: '664af6c86ea5288504dd0fe2',
                    displayName: 'Authentication in APIs',
                    description: 'In this interactive tutorial, you will refresh your knowledge of what the “authentication” term means. You’ll also learn how authentication is implemented and used in the API context.\n',
                    duration: '5-8',
                    iconUrl: null,
                    name: 'authentication_in_ap_is',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2024-05-22T13:05:50.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: null,
                    owasp: null,
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: null,
                    systemCourseDisplayName: 'Cobol',
                    url: '/courses/cobol/lessons/authentication_in_ap_is',
                },
                {
                    id: 511,
                    uuid: '63d136b01d8f6f1974148068',
                    displayName: 'SameSite Cookie Attribute',
                    description: 'In this interactive tutorial, you will learn about the SameSite cookie attribute, its three states, and how to use it.\nPlay and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/1b571577-281a-4080-a45e-1d97b874d757.svg',
                    name: 'samesite_cookie_attribute',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-22T09:45:27.000Z',
                    isCompleted: true,
                    progress: 'completed',
                    cwe: null,
                    owasp: null,
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: true,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f54b3e1260b5cee0448',
                            name: 'frontend',
                            displayName: 'FrontEnd :)',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'test 2 19',
                    url: '/courses/test_2_19/lessons/samesite_cookie_attribute',
                },
                {
                    id: 408,
                    uuid: '62123cc2d72a9bbe90289a4c',
                    displayName: 'Pwnkit',
                    description: 'Known as CVE-2021-4034, Polkit was vulnerable to Local Privilege Escalation (LPE), meaning a non-privileged user can achieve root permissions. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/pawnlit_logo.svg',
                    name: 'pwnkit',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:48.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '60f81f4fd91e8dda3f96ead7',
                            name: 'android',
                            displayName: 'Android',
                        },
                        {
                            uuid: '60f81f50d91e8dfba896ead9',
                            name: 'python',
                            displayName: 'Python Django',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'test 123456',
                    url: '/courses/test_123456/lessons/pwnkit',
                },
                {
                    id: 51,
                    uuid: '6167f2758df887067c76a6cd',
                    displayName: 'Clickjacking',
                    description: 'Clickjacking, also known as a , happens when an attacker uses multiple transparent or opaque layers in the UI to trick a user into clicking a button or a link on another page when they were going to click something on the top level page. Thus, the attacker.',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/click_jacking.png',
                    name: 'click_jacking',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:37.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-451',
                    owasp: 'A4: Insecure Design',
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4db3e126e8dbee043e',
                            name: 'java',
                            displayName: 'Java',
                        },
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '60f81f4eb3e126b119ee043f',
                            name: 'angular',
                            displayName: 'Angular',
                        },
                        {
                            uuid: '61c98bdadd910c1eb58abf92',
                            name: 'click_jacking',
                            displayName: 'Click Jacking',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'test 16',
                    url: '/courses/test_16/lessons/click_jacking',
                },
                {
                    id: 71,
                    uuid: '6167f233c27d3de4eb9529de',
                    displayName: 'Pippo Deserialization',
                    description: 'Pippo is an open source (Apache license) micro web framework in Java, with minimal dependencies and a quick learning curve. It is popular among the developers due to its ease of use. In this interactive tutorial, you will learn about a deserialization vulnerability that has been found recently in Pippo framework. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/hacking_headlines.svg',
                    name: 'pippo_deserialization',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:38.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '60f81f50d91e8dfba896ead9',
                            name: 'python',
                            displayName: 'Python Django',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'test 16',
                    url: '/courses/test_16/lessons/pippo_deserialization',
                },
                {
                    id: 143,
                    uuid: '6167f232c27d3dd2e79529db',
                    displayName: 'eslint scope',
                    description: 'ESLint is a tool for identifying and reporting on patterns found in ECMAScript/JavaScript code. ECMAScript  is a scripting-language specification standardized by Ecma International. eslint scope is the ECMAScript scope analyzer used in ESLint. In this interactive tutorial, you will learn how bad security habits of a developer could cause drastic consequences. Play and learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/hacking_headlines.svg',
                    name: 'eslint_scope',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:40.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'test 123456',
                    url: '/courses/test_123456/lessons/eslint_scope',
                },
                {
                    id: 73,
                    uuid: '6167f2322479f11c1ad557bc',
                    displayName: 'Flask Panel XSS',
                    description: 'Flask-Admin is an extension of a python Flask framework. It lets users add admin interfaces to Flask applications. In this interactive tutorial, we will demonstrate a recent XSS vulnerability found in the Flask-Admin. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/hacking_headlines.svg',
                    name: 'flask_panel_xss',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:38.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-79',
                    owasp: 'A3: Injection',
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                        {
                            uuid: '63a991cf1d8f6fac8612ae33',
                            name: 'flask_panel_xss',
                            displayName: 'Flask Panel Xss',
                        },
                    ],
                    systemCourseDisplayName: 'test 123456',
                    url: '/courses/test_123456/lessons/flask_panel_xss',
                },
                {
                    id: 333,
                    uuid: '6167f2318df88771d876a5e9',
                    displayName: 'Cryptiles',
                    description: 'Cryptiles is an npm package of crypto helper methods. In April 2019, this package was deprecated as a result of a security defect, a new package called @hapi/cryptiles was published and yet, the users kept downloading the deprecated version. In this interactive tutorial, you will learn about vulnerabilities that have been found in Cryptiles and what are the consequences of using a deprecated version. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/hacking_headlines.svg',
                    name: 'cryptiles',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:45.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'tttt',
                    url: '/courses/tttt/lessons/cryptiles',
                },
                {
                    id: 55,
                    uuid: '6167f22bc27d3d21c99529c4',
                    displayName: 'Secure Cookie Flag',
                    description: 'When the Secure flag is set for a cookie, it ensures that this cookie will only be sent via a secure connection. This flag should be set even when HTTPS protocol is used because it protects the cookie from being stolen by an attacker using HTTP redirects. As some cookies can contain sensitive information like session identifiers and can be used by an attacker to steal user sessions and impersonate users in performing malicious actions, every layer of protection is equally important. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/secure_cookie_flag.png',
                    name: 'secure_cookie_flag',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:37.000Z',
                    isCompleted: true,
                    progress: 'completed',
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: '750',
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4db3e126e8dbee043e',
                            name: 'java',
                            displayName: 'Java',
                        },
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '60f81f4eb3e126b119ee043f',
                            name: 'angular',
                            displayName: 'Angular',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'tttt',
                    url: '/courses/tttt/lessons/secure_cookie_flag',
                },
                {
                    id: 49,
                    uuid: '6167f22b2479f18f21d557a1',
                    displayName: 'HTTP Strict-Transport-Security (HSTS)',
                    description: 'sadsa',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/strict_transport_security.png',
                    name: 'strict_transport_security',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:37.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4db3e126e8dbee043e',
                            name: 'java',
                            displayName: 'Java',
                        },
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '60f81f4eb3e126b119ee043f',
                            name: 'angular',
                            displayName: 'Angular',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'Test Publish',
                    url: '/courses/test_publish/lessons/strict_transport_security',
                },
                {
                    id: 57,
                    uuid: '6167f22ac27d3de9589529c1',
                    displayName: 'DOM Open Redirect',
                    description: 'DOM Open Redirects and Forwards (or DOM Unvalidated Redirects and Forwards) are possible when a web application accepts untrusted input that could cause the web application to redirect the request to a URL contained within that untrusted input. By inserting the URL of a malicious site into the untrusted input, an attacker may successfully launch a phishing attack and steal user credentials. In this interactive tutorial, you will learn how URL redirection vulnerabilities are used to compromise the security of a web application, and how to write code more securely to protect against this type of attacks. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/open_redirect.png',
                    name: 'open_redirect',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:37.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-601',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                        {
                            uuid: '63a991cd8e0fc87389c362e0',
                            name: 'open_redirect',
                            displayName: 'Open Redirect',
                        },
                    ],
                    systemCourseDisplayName: 'tets 19',
                    url: '/courses/tets_19/lessons/open_redirect',
                },
                {
                    id: 50,
                    uuid: '6167f22a8df887acce76a5cb',
                    displayName: 'No Server-Side Validation',
                    description: 'asdas',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/no_server_side_validation.png',
                    name: 'no_server_side_validation',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:37.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-602',
                    owasp: 'A4: Insecure Design',
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                        {
                            uuid: '63a991bd1d8f6f292012ae23',
                            name: 'no_server_side_validation',
                            displayName: 'No Server Side Validation',
                        },
                    ],
                    systemCourseDisplayName: 'tttt',
                    url: '/courses/tttt/lessons/no_server_side_validation',
                },
                {
                    id: 61,
                    uuid: '6167f2288df8872b0876a5c5',
                    displayName: 'Vulnerable and Outdated Components',
                    description: 'Code libraries, both proprietary and third-party, need constant maintenance and updates. Even if proprietary code is 100% secure, failure to update third-party components, and particularly updates that mitigate security vulnerabilities, will likely leave environments vulnerable to attack. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/component_known_vulnerability.png',
                    name: 'component_known_vulnerability',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:37.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '60f81f4db3e126e8dbee043e',
                            name: 'java',
                            displayName: 'Java',
                        },
                        {
                            uuid: '60f81f4dd91e8d1d5296ead5',
                            name: 'javascript',
                            displayName: 'JavaScript',
                        },
                        {
                            uuid: '60f81f4eb3e126b119ee043f',
                            name: 'angular',
                            displayName: 'Angular',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'test 2 19',
                    url: '/courses/test_2_19/lessons/component_known_vulnerability',
                },
                {
                    id: 407,
                    uuid: '61f10e5db88486b2a81ccf78',
                    displayName: 'Log4J',
                    description: 'Some versions of Apache Log4j2 are vulnerable to a remote code execution (RCE) attack where an attacker with permission to modify the logging configuration file can construct a malicious configuration which can execute remote code. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/log4j_logo.svg',
                    name: 'log4_j',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:47.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-330',
                    owasp: 'A1: Broken Access Control ',
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                    systemCourseDisplayName: 'tttt',
                    url: '/courses/tttt/lessons/log4_j',
                },
                {
                    id: 72,
                    uuid: '6167f2332479f17ee9d557bf',
                    displayName: 'Vert.X XXE',
                    description: 'Vert.x-Web is a tool-kit for writing sophisticated modern web applications and HTTP microservices. In this interactive tutorial, we will demonstrate a recent XXE vulnerability found in Vert.x-web. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/hacking_headlines.svg',
                    name: 'vertx_xxe',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:38.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-611',
                    owasp: 'A3: Injection',
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                        {
                            uuid: '63a991cf8e0fc81ecfc362e6',
                            name: 'vertx_xxe',
                            displayName: 'Vertx Xxe',
                        },
                    ],
                    systemCourseDisplayName: 'tttt',
                    url: '/courses/tttt/lessons/vertx_xxe',
                },
                {
                    id: 314,
                    uuid: '6167f2312479f1a315d557b9',
                    displayName: 'Apache Unomi',
                    description: 'Apache Unomi is a Java open-source platform for managing customers and tracking their behavior. In this interactive tutorial, you will learn about Remote Code Execution vulnerabilities that have been found recently in Apache Unomi. Play and Learn...',
                    duration: '5-8',
                    iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/hacking_headlines.svg',
                    name: 'apache_unomi',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2023-03-21T08:19:44.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: 'CWE-74',
                    owasp: 'A3: Injection',
                    sans: null,
                    potentialPoints: 0,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: [
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                        {
                            uuid: '63a991cf1d8f6f2b5312ae35',
                            name: 'apache_unomi',
                            displayName: 'Apache Unomi',
                        },
                    ],
                    systemCourseDisplayName: 'Test Publish',
                    url: '/courses/test_publish/lessons/apache_unomi',
                },
                {
                    id: 729,
                    uuid: '663771aa6ea528a8dedae8e5',
                    displayName: 'Privilege Escalation: Cloud Platform Metadata ',
                    description: 'In this lesson, we will learn about Privilege Escalation through vulnerabilities associated with cloud platform metadata services. Learn how attackers exploit these services to gain unauthorized access to cloud resources.',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/15b9e0e9-30a5-4cdd-b5a0-1ed0e6709236.webp',
                    name: 'privilege_escalation_cloud_platform_metadata',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2024-05-05T12:07:08.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: null,
                    owasp: null,
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: null,
                    systemCourseDisplayName: 'Test Publish',
                    url: '/courses/test_publish/lessons/privilege_escalation_cloud_platform_metadata',
                },
                {
                    id: 718,
                    uuid: '66374e9715b138dbedb1e541',
                    displayName: 'Overview Part One',
                    description: 'In this lesson, we will provide an overview of the course and the topics that will be covered. Wel also discuss the importance of understanding the risks associated with cloud platforms and the need to secure them.',
                    duration: '5-8',
                    iconUrl: 'https://content.codebashing.com/courses-assets/0ebc1ec4-5aec-462c-ab37-d99295535276.webp',
                    name: 'overview_part_one',
                    type: 'system',
                    activeOnLean: false,
                    createdAt: '2024-05-05T12:07:08.000Z',
                    isCompleted: false,
                    progress: null,
                    cwe: null,
                    owasp: null,
                    sans: null,
                    potentialPoints: 1000,
                    doneRecently: false,
                    earnedPoints: 0,
                    assignedToMe: false,
                    dueDate: null,
                    tags: null,
                    systemCourseDisplayName: 'Test Publish',
                    url: '/courses/test_publish/lessons/overview_part_one',
                },
            ],
        },
        {
            contentType: 'Course',
            data: [
                {
                    uuid: 'c82824bb-f941-4f6f-b057-fae3599210ed',
                    displayName: 'Cobol',
                    description: '(under development)',
                    tagline: null,
                    iconUrl: 'https://content.codebashing.com/courses-assets/c6249588-d8d8-4fda-94e8-3457c4c86e85.webp',
                    name: 'cobol',
                    publishedAt: '2024-05-22T13:08:44.000Z',
                    activeOnLean: false,
                    isPrimary: false,
                    assignedToMe: false,
                    dueDate: null,
                    score: 0,
                    completionPercentage: 0,
                    progress: null,
                    hasCertificate: false,
                    isSystem: true,
                    numberOfLessons: 3,
                    totalDuration: 15,
                    quizStatus: null,
                    tags: null,
                },
                {
                    uuid: '34311610-4d8a-4d7d-997f-ea03f9ff22dd',
                    displayName: 'test 16',
                    description: 'test 16',
                    tagline: null,
                    iconUrl: 'https://platform-ui-spa.devcodebashing.com/icons/customCourses/default/custom-course-default.webp',
                    name: 'test_16',
                    publishedAt: '2024-05-20T06:56:28.000Z',
                    activeOnLean: false,
                    isPrimary: false,
                    assignedToMe: false,
                    dueDate: null,
                    score: 0,
                    completionPercentage: 0,
                    progress: null,
                    hasCertificate: false,
                    isSystem: true,
                    numberOfLessons: 12,
                    totalDuration: 60,
                    quizStatus: null,
                    tags: null,
                },
                {
                    uuid: 'fe7e69a1-66d3-4a27-99aa-cccf1f220911',
                    displayName: 'tttt',
                    description: 'yyyyyy',
                    tagline: null,
                    iconUrl: 'https://platform-ui-spa.devcodebashing.com/icons/customCourses/default/custom-course-default.webp',
                    name: 'tttt',
                    publishedAt: '2024-05-20T05:48:05.000Z',
                    activeOnLean: false,
                    isPrimary: false,
                    assignedToMe: false,
                    dueDate: null,
                    score: 0,
                    completionPercentage: 0,
                    progress: null,
                    hasCertificate: false,
                    isSystem: true,
                    numberOfLessons: 6,
                    totalDuration: 30,
                    quizStatus: null,
                    tags: null,
                },
                {
                    uuid: '97eafdd6-a71a-4f3d-910d-2a6b6bb9bb70',
                    displayName: 'test 123456',
                    description: 'tets units',
                    tagline: null,
                    iconUrl: 'https://platform-ui-spa.devcodebashing.com/icons/customCourses/default/custom-course-default.webp',
                    name: 'test_123456',
                    publishedAt: '2024-05-20T05:47:17.000Z',
                    activeOnLean: false,
                    isPrimary: false,
                    assignedToMe: false,
                    dueDate: null,
                    score: 0,
                    completionPercentage: 0,
                    progress: null,
                    hasCertificate: false,
                    isSystem: true,
                    numberOfLessons: 6,
                    totalDuration: 30,
                    quizStatus: null,
                    tags: null,
                },
            ],
        },
        {
            contentType: 'LearningPath',
            data: [],
        },
        {
            contentType: 'SkillTree',
            data: [],
        },
        {
            contentType: 'Challenge',
            data: [],
        },
        {
            contentType: 'VideoTutorial',
            data: [],
        },
        {
            contentType: 'Lab',
            data: [
                {
                    id: 123,
                    uuid: 'abcd',
                    displayName: 'Java hands on labs',
                    description: 'Select your next expertise and follow a dynamic gamified learning to obtain your certification!',
                    duration: '23',
                    potentialScore: 30000,
                    earnedScore: 200,
                    name: ' Java hands on labs',
                    isCompleted: false,
                    progress: '25',
                    tags: [
                        {
                            uuid: '60f81f54b3e1260b5cee0448',
                            name: 'frontend',
                            displayName: 'FrontEnd :)',
                        },
                        {
                            uuid: '61c98bddcdfbc8ca10eae27d',
                            name: 'use_of_insufficiently_random_values',
                            displayName: 'Use Of Insufficiently Random Values',
                        },
                        {
                            uuid: '63a991bb1d8f6f722a12ae1d',
                            name: 'anti_xss_mechanism_url_sanitaizer',
                            displayName: 'Anti Xss Mechanism Url Sanitaizer',
                        },
                    ],
                },
            ],
        },
    ],
    total: 10,
    success: true,
};
